import { usePaginatedServices } from 'queries/services/use-paginated-services'
import { ms } from 'utils/time/millisecond'

const PAGE_SIZE = 1
const STALE_TIME = ms.seconds(30)

export function useHasServices() {
  const {
    data: services,
    isError: isServicesError,
    isFetching: isServicesLoading
  } = usePaginatedServices(PAGE_SIZE, {
    staleTime: STALE_TIME
  })
  return {
    hasServices: services?.items ? services.items.length > 0 : false,
    isServicesError,
    isServicesLoading
  }
}
